/**
 * Tab modules
 */
export * from './tab';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-navigations/src/tab/index.js
// module id = 1874
// module chunks = 0